export type RawPlayer = {
  n?: string;
  n1?: string;
  n2?: string;
  sub?: boolean;
  sh?: string;
  pa?: string;
  ta?: string;
  xg?: string;
  st?: string;
  as?: string;
  goal?: string;
  ycard?: string;
  rcard?: string;
  fouls?: string;
  cr?: string;
  kp?: string;
  sv?: string;
  paAcc?: string;
  subs?: string;
};

export type LineupSide = { n?: string; ply?: Record<string, RawPlayer> };
export type Lineups = { h?: LineupSide; a?: LineupSide };

export type Metric =
  | "list"
  | "assists"
  | "crosses"
  | "fouls"
  | "goals"
  | "keyPasses"
  | "passAccuracy"
  | "passes"
  | "red"
  | "saves"
  | "shots"
  | "tackles"
  | "yellow"
  | "xg";

export const metricLabel: Record<Metric, string> = {
  list: "LIST",
  assists: "Assists",
  crosses: "Crosses",
  fouls: "Fouls",
  goals: "Goals",
  keyPasses: "Key Passes",
  passAccuracy: "Pass Accuracy",
  passes: "Passes",
  red: "Red",
  saves: "Saves",
  shots: "Shots",
  tackles: "Tackles",
  yellow: "Yellow",
  xg: "xG",
};

export type PlayerVM = {
  id: string;
  name: string;
  passes: number;
  tackles: number;
  fouls: number;
  xg: number;
  assists: number;
  goals: number;
  yellow: number;
  red: number;
  crosses: number;
  keyPasses: number;
  saves: number;
  shots: number;
  passAccuracy: number;
  isSub: boolean;
};
